module.exports = __webpack_public_path__ + "static/media/shipping-banner.5e0a950e.png";